<div class="content-pane readable">
  <div class="content">
    <div class="content-body">
      <div class="content-main">
        <div class="meta-header">
          <h3>Dataset Details</h3>
          @if (dataset()?._can_update_meta) {
          <span class="action-button">
            <a [routerLink]="pdeRoutes.datasetEditDetails(dataset().id)" mat-button>
              <mat-icon class="material-symbols-outlined">edit</mat-icon>
              Edit
            </a>
          </span>
          }
        </div>
        <div class="content-container">
          <div class="content-header">
            <h2 class="content-title">{{ dataset()?.name }}</h2>
          </div>
          <div class="content-toolbar">
            @if(dataset()?.link_to_external_dataset){
            <a
              [href]="dataset().link_to_external_dataset"
              target="_blank"
              rel="noopener"
              class="content-header-action toolbar-action"
            >
              <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
              View External Dataset
            </a>
            } @if(unaffected_by_hsd_download_restrictions() && dataset()?._can_download_latest_data &&
            !!latestFileVersion()){
            <a
              class="content-header-action toolbar-action"
              (click)="downloadLatestVersion()"
              (keydown.enter)="downloadLatestVersion()"
            >
              <mat-icon class="material-symbols-outlined">download</mat-icon>
              Download Latest Version ({{formatFileSize(latestFileVersion().file_version.file_size)}})
            </a>
            } @if(dataset()?.visible_to_all_users && projectStub().visible_to_all_users){
            <a class="content-header-action toolbar-action" [routerLink]="pdcRoutes.datasetView(dataset().id)">
              <mat-icon class="material-symbols-outlined">search_insights</mat-icon>
              View in Public Data Commons
            </a>
            }
          </div>
          <div class="description" [innerHTML]="safeDescription()"></div>
          <div class="meta-subcontent">
            <app-key-value-table [rowsToDisplay]="buildKeyValueTable()"></app-key-value-table>
          </div>
          @if(dataset()?.dataset_type == "DICOM"){
          <p>The fields listed below are automatically populated from the most recently uploaded DICOM file.</p>
          <app-key-value-table [rowsToDisplay]="buildDicomTable()"></app-key-value-table>
          }
        </div>
      </div>
      @if((dataset()?._can_download_all_data || dataset()?._can_upload_data) &&
      (unaffected_by_hsd_download_restrictions() || (dataset()?._can_delete_data &&
      dataset().dataset_file_versions.length>0))){
      <app-file-table [container]="dataset" [flags]="dataset()" tablename="Dataset File Version"></app-file-table>
      }
      <div class="content-sidebar">
        @if(dataset()?._can_view_permission){
        <div class="access-section">
          <div class="meta-header">
            <h3>Dataset Access</h3>
            @if(dataset()?._can_manage_permission){
            <span class="action-button">
              <a [routerLink]="pdeRoutes.datasetEditAccess(dataset().id)" mat-button>
                <mat-icon class="material-symbols-outlined">edit</mat-icon>
                Edit
              </a>
            </span>
            }
          </div>
          <h3 class="meta-subheader flat">Public Data Commons Dataset Details Visibility</h3>
          <div class="meta-subcontent flat">
            @if (dataset()?.visible_to_all_users) {
            <span>Visible in the Public Data Commons</span>
            } @else {
            <span>Not visible in the Public Data Commons</span>
            }
          </div>

          @if(can_show_file_publicity_status()){
          <h3 class="meta-subheader flat">Public Data Commons Dataset File Visibility</h3>
          <div class="meta-subcontent flat">
            @if (dataset()?.is_data_public) {
            <span>Visible in the Public Data Commons</span>
            } @else {
            <span>Not visible in the Public Data Commons</span>
            }
          </div>
          }

          <div class="meta-subcontent">
            <app-permissions-table
              [context]="datasetPermissionContext"
              [rows]="datasetPermissions"
            ></app-permissions-table>
          </div>

          @if (dataset()?._can_delete_meta) {
          <div class="actions dataset">
            <a [routerLink]="pdeRoutes.datasetEditAccessDelete(dataset().id)" matButton="filled" class="delete danger">
              <mat-icon class="material-symbols-outlined">delete</mat-icon>Delete
            </a>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #hsd_download_attestation>
  By clicking "Yes" below, I confirm that I have reviewed the <a (click)="openDSP()">Data Security Plan</a> for
  <b>{{ dataset().name }}</b>. I am saving this file to a location listed on my DSP and approved for Highly Sensitive
  Data.
</ng-template>

<ng-template #non_hsd_download_attestation>
  By clicking "Yes" below, I confirm that this file for <b>{{ dataset().name }}</b> does NOT contain any highly
  sensitive data. I will save this file to an appropriate location as defined by organizational policy.
</ng-template>
